module.exports = __webpack_public_path__ + "static/media/google-icon.69ce7fd5.svg";